import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { STATISTIC_GOALS_BY_MANAGER_GET } from 'api/query-keys.ts';
import type { TCargoType, TGetGoalsByManagerStatisticsRes } from 'api/swagger';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  date: string;
  period: 'day' | 'week';
  transportLine: string;
  cargoTypes: TCargoType[];
}

export const useGetGoalsByManagerStatistic = (params: IParams) => {
  const qs = new URLSearchParams();

  setFiltersToQs<IParams>(qs, params);

  return useQuery<TGetGoalsByManagerStatisticsRes>({
    queryKey: [STATISTIC_GOALS_BY_MANAGER_GET, { params }],
    queryFn: async () => {
      const { data } = await http.get<TGetGoalsByManagerStatisticsRes>(
        `/v1/statistics/goals-by-manager?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!params.transportLine,
  });
};
